import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { List } from '@fuww/components/src/List';
import { NewsListItemContent, NewsListItem }
from '@fuww/components/src/List/NewsList';
import { ListItemImageContainer }
from '@fuww/components/src/List/Styled';
import LinkAndAnchor from '../../LinkAndAnchor';
import SiteContext from '../../SiteContext';
import getArticlesParameters from '../../../lib/getArticlesParameters';
import ImageWithUrls from '../../ImageWithUrls';
import getCategoryTitle from '../../../lib/getCategoryTitle';

const ArticleList = ({
  newsArticles,
  showImage,
  showCategory,
  noBorderFirstItem,
}) => {
  const intl = useIntl();
  const { hasLocalNews, complete } = useContext(SiteContext);

  return (
    <>
      <List className="fu-mdc-list" resetpadding>
        {newsArticles.map((newsArticle) => {
          const {
            id, title: listTitle, path, imageUrls, category,
          } = newsArticle;

          return (
            <React.Fragment key={id}>
              <NewsListItem noBorderFirstItem={noBorderFirstItem}>
                <LinkAndAnchor
                  route="article"
                  params={getArticlesParameters(newsArticle)}
                  href={path}
                  useRouter={complete}
                >
                  <NewsListItemContent
                    title={listTitle}
                    category={
                      showCategory
                      && getCategoryTitle(category, hasLocalNews, intl)
                    }
                    imageRight={showImage && imageUrls[0] && (
                      <ListItemImageContainer>
                        <ImageWithUrls
                          imageUrls={imageUrls}
                          alt={listTitle}
                          width="80px"
                          height="80px"
                          sizes="80px"
                          srcSet={`${imageUrls[1]
                          } 80w, ${imageUrls[2]
                          } 160w, ${imageUrls[3]
                          } 320w`}
                        />
                      </ListItemImageContainer>
                    )}
                    tag="h3"
                  />
                </LinkAndAnchor>
              </NewsListItem>
            </React.Fragment>
          );
        })}
      </List>
    </>
  );
};

ArticleList.propTypes = {
  newsArticles: PropTypes.arrayOf(PropTypes.shape({})),
  showImage: PropTypes.bool,
  showCategory: PropTypes.bool,
  noBorderFirstItem: PropTypes.bool,
};

ArticleList.defaultProps = {
  newsArticles: [],
  showImage: null,
  showCategory: null,
  noBorderFirstItem: null,
};

export default ArticleList;
